import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { loginWithToken } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data)).catch(() => setInfo(false)); }, [token]);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/auth/set-password", { token, password: pw });
      await loginWithToken(r.data.token);
      toast.success("Password impostata. Benvenuto in Otelya!");
      nav("/dashboard");
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center px-6" data-testid="set-password-page">
      <div className="w-full max-w-md rounded-2xl border border-line bg-canvas p-8">
        <Logo />
        {info === null && <div className="text-stone mt-6">Verifica invito…</div>}
        {info === false && <div className="text-terracotta mt-6" data-testid="set-password-invalid">Invito non valido o scaduto. Chiedi al tuo gestore di inviarne uno nuovo.</div>}
        {info && (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="font-serif text-2xl text-ink">Attiva {info.property_name}</div>
            <div className="text-sm text-stone">{info.email}</div>
            <Input type="password" required minLength={8} placeholder="Scegli una password (min 8 caratteri)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" />
            <Button disabled={busy} className="w-full rounded-full bg-ink text-canvas hover:bg-olive" data-testid="set-password-submit">{busy ? "Attendi…" : "Attiva account"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
